<template>
  <div>
    <NotificationReminderContainer
      :reports="reports"
      :feature-name="NOTIFICATION_FEATURES_NAME.FEE_MANAGER"
    />
  </div>
</template>

<script>
import NotificationReminderContainer from '@/src/components/Settings/notifications/NotificationReminderContainer.vue'
/* Utils or mixins */

import NOTIFICATION_FEATURES_NAME from '@src/constants/notification-constants.js'

export default {
  components: {
    NotificationReminderContainer,
  },
  page: {
    title: 'Notification | Fee',
    meta: [
      {
        name: 'description',
        content: 'Fee Notification System',
      },
    ],
  },
  data() {
    return {
      NOTIFICATION_FEATURES_NAME,
      reports: ['monthly'],
    }
  },
}
</script>
